module.exports = __webpack_public_path__ + "img/myneofintech.cf97ea9b.png";